// import { Flex, Typography } from 'components';
// import React, { ReactElement } from 'react';

// const ErrorBoundary = (): ReactElement => (
//   <Flex>
//     <Typography type="type6" color="alert_400" fontWeight="bold">
//       Desculpe, algo deu errado!
//     </Typography>
//   </Flex>
// );

// export default ErrorBoundary;

import React, { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error;
  info: ErrorInfo | null;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { error: undefined!, info: null };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    this.setState({
      error,
      info,
    });
  }

  render(): ReactNode {
    const { error, info } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <div style={{ background: 'red' }}>
          <h3>Sorry Something went wrong!</h3>

          <p>{error && error.toString()}</p>
          <p>{info?.componentStack}</p>
        </div>
      );
    }
    return children;
  }
}
